import i18n from "i18next";
import { all, delay, getContext, race, take, takeLatest } from "typed-redux-saga";
import { increment } from "../slices/counterSlice";

function* testSaga() {
    console.log("testSaga called, tnaslation: " + i18n.t("currencies.EUR"));

    const apiClient = yield* getContext("apiClient");
    console.log("yaou can use apiClient from context:", apiClient);

    const { inremented, timedOut } = yield* race({
        inremented: take(increment.type),
        timedOut: delay(1000),
    });

    if (inremented) {
        console.log("incremented action received");
    }

    if (timedOut) {
        console.log("timed out after 1 second");
    }
}

export function* counterSaga() {
    yield* all([takeLatest(increment.type, testSaga)]);
}
